<ng-container *ngIf="vm$ | async as vm">
  <form class="zoek__form" name="frmZoekDocumentZitting" (ngSubmit)="searchCmdSubj.next(true)">

    <div class="zoekpanel__row">
      <h1 class="head1">Zoeken document zitting</h1>
      <div class="zoekinput__row">
        <input title="Geef zoektermen in" class="zoekinput" type="text" name="searchFor" [(ngModel)]="vm.searchArgs.SearchFor">
        <button type="submit" class="btn btn-primary ">zoeken<i class="icon-zoom"></i></button>
        <button (click)="navigateToZoekAgendapunten(vm.searchArgs)" type="button" class="btn btn-primary">agendapunten<i
            class="icon-zoom"></i></button>
        <button (click)="navigateToZoekNotities(vm.searchArgs)" type="button" class="btn btn-primary">notities<i
            class="icon-zoom"></i></button>
      </div>
      <div class="zoekfilters__row">
        <select name="soortzitting" title="Filter soort zitting" [(ngModel)]="vm.searchArgs.SoortZittingId">
          <option [ngValue]="null">Alle zittingen</option>
          <option [ngValue]="soortZitting.Id" *ngFor="let soortZitting of vm.soortenZitting">
            {{soortZitting.Omschrijving}}</option>
        </select>

        <select name="periodeFilter" title="Filter periode" [(ngModel)]="vm.searchArgs.PeriodeFilter">
          <option [value]="periodeFilter.arg" *ngFor="let periodeFilter of vm.periodeFilters">{{periodeFilter.Title}}
          </option>
        </select>

        <select name="andorfilter" title="Optie combineer zoektermen" [(ngModel)]="vm.searchArgs.CombineWordsWith">
          <option selected="selected" value=" or ">Eén van de...</option>
          <option value=" and ">Alle...</option>
          <option value="exact">Exact</option>
        </select>

        <a href="#" role="button" (click)="wisZoekFilters()" class="size1 c2-clickable">wissen</a>
      </div>
      <div class="zoekinput__row" *ngIf="vm.searchArgs.PeriodeFilter=='C'">
        <label for="zoekdoczitting_vanjaar">Van jaar</label>
        <input id="zoekdoczitting_vanjaar" class="jaar" type="number" name="vanJaar" [(ngModel)]="vm.searchArgs.VanJaar" min="1970" max="2099">
        <label for="zoekdoczitting_totjaar">Tot jaar (optioneel)</label>
        <input id="zoekdoczitting_totjaar" class="jaar" type="number" name="totJaar" [(ngModel)]="vm.searchArgs.TotJaar" min="" max="2099">
      </div>
    </div>

  </form>

  <div role="list" class="zoek__resultspanel">
    <span class="head3" *ngIf="vm.searchResults.length==0">Geen resultaten</span>
    <div role="listitem" class="zoekresults__itemrow" *ngFor="let item of vm.searchResults trackBy:getResultId">

      <h2 [id]="'z_'+item.ZittingId" class="zoekresults__zitting" *ngIf="item.isZittingBreak">
        <a class="head2 c2-inline c2-clickable" href="#" (click)="navigateToDetailZitting(item)">{{item.SoortZitting}}
          {{item.Datum | date}}</a>
      </h2>
      
      <a class="zoekresults__document c2-clickable" href="#" (click)="openDocument(item)">
        <i aria-label="Document" class="icon-file"></i> {{item.Titel}}
      </a>

    </div>
    <div class="zoekresults__buttonrow" *ngIf="vm.hasMoreResults">
      <button (click)="searchMoreCmdSubj.next(true)" class="btn btn-primary">Meer...</button>
    </div>
  </div>
</ng-container>